import {useEffect, useLayoutEffect, useRef} from 'react';

export const WORKSPACE_PAGES = [
  ['dashboard', 'Home'], ['trades', 'Journal'], ['stats', 'Analytics'],
  ['outlooks', 'Plans'], ['reviews', 'Reviews'], ['accounts', 'Accounts'],
  ['wall', 'The Wall'], ['ai', 'AI insights'], ['card', 'Trade cards'],
];

export function workspaceNeighbours(view, {hiddenViews = [], accountMode = true, editing = false, busy = false} = {}) {
  const pages = WORKSPACE_PAGES.filter(([id]) => !hiddenViews.includes(id) && (id !== 'accounts' || accountMode));
  const index = pages.findIndex(([id]) => id === view);
  if (index < 0 || editing || busy) return {enabled: false};
  return {enabled: true, previous: pages[index - 1], next: pages[index + 1]};
}

// Keep positions in this signed-in session only; never persist private navigation.
export function useWorkspaceScroll(view, owner, ready, startAtTop=false, containerSelector) {
  const positions = useRef(new Map()), active = useRef(null);
  useEffect(() => {
    if (!ready) return;
    const container = containerSelector && document.querySelector(containerSelector);
    const target = container || window;
    const remember = () => {if (active.current) positions.current.set(active.current.view, container ? container.scrollTop : window.scrollY);};
    target.addEventListener('scroll', remember, {passive: true});
    return () => target.removeEventListener('scroll', remember);
  }, [ready, containerSelector]);
  useLayoutEffect(() => {
    if (active.current?.owner !== owner) positions.current.clear();
    if (!ready) {active.current = null; return;}
    active.current = {view, owner};
    const target = (containerSelector && document.querySelector(containerSelector)) || window;
    const top = startAtTop ? 0 : positions.current.get(view) || 0;
    if (target.scrollTo) target.scrollTo({top, left: 0, behavior: 'instant'});
    else target.scrollTop = top;
  }, [view, owner, ready, startAtTop, containerSelector]);
}
